import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import $ from "jquery";
import { useEffect, useRef, useState } from "react";
import { dnbGetCookie, dnbSetCookie, extIcon, getViewportIsMobile, isNotUndefined, isUndefined, languagePreferenceCookieName, sitePreferenceCookieName, unitedStatesIsoCode } from "../FunctionsCore";
import { classCombinerFromPrefix } from "../RenderIdentifier";
import WebsiteSelectorStyles from "./WebsiteSelectorStyles.module.scss";
const styles = WebsiteSelectorStyles;
const classCombiner = classCombinerFromPrefix("b63iu12a544b3f9c");
const WebsiteSelector = (properties) => {
    const { isoCode, siteLanguage, websiteSelectorSiteArray, websiteSelectorTitleEn, websiteSelectorTitleFr } = properties;
    // TODO Fix
    const websiteSelectorSiteArrayParsed = window.JSON.parse(websiteSelectorSiteArray);
    const htmlDivElementReference = useRef(null);
    const htmlUListElement = useRef(null);
    const [websiteSelectorTimeout, setWebsiteSelectorTimeout] = useState();
    const getWebsiteSelector = () => $(htmlDivElementReference.current);
    const closeWebsiteSelector = () => {
        const $websiteSelector = getWebsiteSelector();
        $websiteSelector.fadeOut(500, () => $websiteSelector.remove());
    };
    const set = (seconds) => setWebsiteSelectorTimeout(window.setTimeout(closeWebsiteSelector, seconds * 1000));
    const clear = () => {
        if (isNotUndefined(websiteSelectorTimeout)) {
            window.clearTimeout(websiteSelectorTimeout);
        }
    };
    const cookieExpirationInDays = 30;
    useEffect(() => {
        // TODO Does not work
        const windowCountryName = window["country_name"];
        let geolocationCountryCode;
        // Get the geolocation country name from Adobe Target
        if (isNotUndefined(windowCountryName)) {
            // Use Adobe Target geolocated country name to look up country code in site array
            for (const country of websiteSelectorSiteArrayParsed) {
                const countryName = country.name;
                if (countryName.toLowerCase().match(windowCountryName.toLowerCase()) !== null) {
                    geolocationCountryCode = country.code;
                }
            }
        }
        // Default to US
        const geolocationCountryCodeToUse = isUndefined(geolocationCountryCode) ? unitedStatesIsoCode : geolocationCountryCode;
        const languagePreference = dnbGetCookie(languagePreferenceCookieName);
        const sitePreference = dnbGetCookie(sitePreferenceCookieName);
        const browserLanguage = window.navigator.language.slice(0, 2);
        let appendWebsiteSelectorItems = false;
        // If no cookies
        if (isUndefined(languagePreference) && isUndefined(sitePreference)) {
            dnbSetCookie(languagePreferenceCookieName, siteLanguage, cookieExpirationInDays);
            dnbSetCookie(sitePreferenceCookieName, siteLanguage, cookieExpirationInDays);
            // If browser language is different from site language
            // If geo is different from current site
            if (browserLanguage !== siteLanguage.slice(0, 2) || (geolocationCountryCodeToUse !== isoCode)) {
                appendWebsiteSelectorItems = true;
            }
        }
        else {
            const languagePreferenceSlice = isNotUndefined(languagePreference) ? languagePreference.slice(0, 2) : "";
            // If language preference is different from site language
            // If geo is different from current site
            if (languagePreferenceSlice !== siteLanguage.slice(0, 2)) {
                appendWebsiteSelectorItems = true;
            }
        }
        if (appendWebsiteSelectorItems && geolocationCountryCodeToUse !== isoCode) {
            const windowLocation = window.location;
            const $ul = $(htmlUListElement.current);
            // Order list of sites
            // Take US to last
            const takeUsLastinList = websiteSelectorSiteArrayParsed.shift();
            websiteSelectorSiteArrayParsed.push(takeUsLastinList);
            // If Canada fr take fr to top
            if (siteLanguage.slice(0, 2) === "fr") {
                const frSite = websiteSelectorSiteArrayParsed[0];
                websiteSelectorSiteArrayParsed[0] = websiteSelectorSiteArrayParsed[1];
                websiteSelectorSiteArrayParsed[1] = frSite;
            }
            for (const country of websiteSelectorSiteArrayParsed) {
                const { code, language } = country;
                if (code === geolocationCountryCodeToUse || code === isoCode) {
                    const windowLocationHref = windowLocation.href;
                    const windowLocationOrigin = windowLocation.origin;
                    const domainList = ["dnb.com", "dnb.co.uk", "dnb.com/ca", "dnb.com/ie"];
                    const isProduction = domainList.some((st) => windowLocationOrigin.includes(st));
                    let url;
                    // Link manipulations for production and author
                    if (isProduction) {
                        // On production
                        const pathname = windowLocation.pathname.replace("/ca-en", "").replace("/ca-fr", "").replace("/ie", "");
                        url = country.url + pathname;
                    }
                    else if (code === unitedStatesIsoCode) {
                        url = windowLocationHref.replace("-ca", "-us").replace("-uk", "-us").replace("-ie", "-us").replace("/fr/", "/en/");
                    }
                    else {
                        // On author
                        const slice = language.slice(0, 2);
                        if (windowLocationHref.includes("/en/")) {
                            url = windowLocationHref.replace("/en/", `/${slice}/`);
                        }
                        else if (windowLocationHref.includes("/fr/")) {
                            url = windowLocationHref.replace("/fr/", `/${slice}/`);
                        }
                        else {
                            throw new Error("Unexpected language code");
                        }
                    }
                    const link = window.document.createElement("a");
                    link.href = url;
                    link.innerHTML = country.name;
                    link.dataset["language"] = language;
                    // Add class for external sites
                    if (code !== isoCode) {
                        link.classList.add(extIcon);
                        link.setAttribute("target", "_blank");
                    }
                    $(link).on("click", function (cl) {
                        const $this = $(this);
                        const dataLanguage = $this.attr("data-language");
                        const href = $this.attr("href");
                        // Set language and site preference
                        dnbSetCookie(languagePreferenceCookieName, dataLanguage, cookieExpirationInDays);
                        dnbSetCookie(sitePreferenceCookieName, dataLanguage, cookieExpirationInDays);
                        const dataLanguageLowerCase = dataLanguage.toLowerCase();
                        if (dataLanguageLowerCase === siteLanguage.toLowerCase()) {
                            // Stay on page
                            cl.preventDefault();
                        }
                        else if (href === windowLocationHref) {
                            // Stay on page
                            cl.preventDefault();
                        }
                        closeWebsiteSelector();
                    });
                    const htmlLiElement = window.document.createElement("li");
                    htmlLiElement.append(link);
                    $ul.append(htmlLiElement);
                }
            }
            getWebsiteSelector().fadeIn(1500);
            // TODO Fix
            if (getViewportIsMobile()) {
                // Do not set timeout
            }
            else {
                set(8);
            }
        }
    }, []);
    return (_jsxs("div", Object.assign({ className: cx(classCombiner(styles, "website_selector")), onMouseEnter: clear, onMouseLeave: () => set(1), ref: htmlDivElementReference }, { children: [_jsx("button", { "aria-label": "Close", className: cx(classCombiner(styles, "close"), "close"), onClick: () => {
                    clear();
                    closeWebsiteSelector();
                    dnbSetCookie(languagePreferenceCookieName, siteLanguage, 30);
                    dnbSetCookie(sitePreferenceCookieName, siteLanguage, 30);
                }, type: "button" }), _jsx("ul", Object.assign({ className: cx(classCombiner(styles, "website_selector_ul")), ref: htmlUListElement }, { children: _jsx("li", Object.assign({ className: cx(classCombiner(styles, "title")) }, { children: siteLanguage.includes("en-") ? websiteSelectorTitleEn : websiteSelectorTitleFr })) }))] })));
};
export { WebsiteSelector };
